<template>
  <div>
    <Header />
    <v-img
      :src="require('@/assets/contact-banner.png')"
      aspect-ratio="3.839"
      contain
    >
      <template v-slot:placeholder>
        <v-row class="fill-height ma-0" align="center" justify="center">
          <v-progress-circular
            indeterminate
            color="grey lighten-5"
          ></v-progress-circular>
        </v-row>
      </template>
    </v-img>

    <v-row align="center" justify="center" no-gutters>
      <v-breadcrumbs :items="itemsBreadcrumbs" large>
        <template v-slot:divider>
          <v-icon>mdi-forward</v-icon>
        </template>
      </v-breadcrumbs>
    </v-row>

    <v-container>
      <v-row class="d-flex justify-space-around">
        <v-col cols="12" md="6">
          <v-card max-width="500" class="mx-auto">
            <v-card-title class="light-blue accent-4 lighten-2"
              >Nuestros Contactos</v-card-title
            >
            <v-list three-line>
              <v-list-item-group color="primary">
                <v-list-item v-for="(item, i) in itemsContacto" :key="i">
                  <v-list-item-icon>
                    <v-icon>{{ item.icon }}</v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title>{{ item.titulo }}</v-list-item-title>
                    <v-list-item-subtitle>{{
                      item.descripcion
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-card>
        </v-col>

        <v-col cols="12" md="6">
          <v-card max-width="500" class="mx-auto">
            <v-card-title class="light-blue accent-4 lighten-2"
              >Solicita información aquí</v-card-title
            >
            <v-form ref="form" v-model="valid">
              <v-container>
                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="Request.Nombre"
                      label="Nombre"
                      :rules="nombreRules"
                      outlined
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="Request.Apellido"
                      label="Apellido"
                      :rules="apellidoRules"
                      outlined
                      color="blue"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12">
                    <v-text-field
                      v-model="Request.Correo"
                      label="Correo"
                      :rules="emailRules"
                      outlined
                      color="blue"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12">
                    <v-text-field
                      v-model="Request.Telefono"
                      label="Teléfono"
                      outlined
                      hint="*Opcional"
                      persistent-hint
                      color="blue"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12">
                    <v-textarea
                      v-model="Request.Comentario"
                      outlined
                      label="Comentario"
                      row-height="1"
                      auto-grow
                      hint="*Opcional"
                      persistent-hint
                      color="blue"
                    >
                    </v-textarea>
                  </v-col>

                  <v-col cols="12">
                    <v-btn
                      block
                      color="primary"
                      class="ma-1"
                      :disabled="!valid"
                      :loading="loading"
                      @click="enviarSolicitud()"
                      >ENVIAR</v-btn
                    >
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <v-container>
      <p
        class="text-center fontTitulo"
        :class="[
          $vuetify.breakpoint.mdAndUp ? 'fontTitulo' : 'fontTituloResponsive',
        ]"
      >
        Enterate de nuestras publicaciones
      </p>
      <v-container>
        <v-col cols="12">
          <v-row justify="center" align="center">
            <v-card class="mx-auto">
              <iframe
                src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FAsistencia-Regional-100590618415592&tabs=timeline&width=340&height=500&small_header=true&adapt_container_width=true&hide_cover=false&show_facepile=true&appId=931301804039673"
                width="340"
                height="500"
                style="border: none; overflow: hidden"
                scrolling="no"
                frameborder="0"
                allowfullscreen="true"
                allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
              ></iframe>
            </v-card>
            <v-card class="mx-auto">
              <a
                class="twitter-timeline"
                href="https://twitter.com/Asis_Regional?ref_src=twsrc%5Etfw"
                data-width="400"
                data-height="500"
                data-chrome="nofooter noborders"
                data-aria-polite="assertive"
                >Tweets por Asistencia Regional
              </a>
            </v-card>
          </v-row>
        </v-col>
      </v-container>
    </v-container>

    <v-snackbar v-model="snackbarSuccess" :timeout="timeout" color="blue" right>
      {{ textSuccess }}
    </v-snackbar>

    <v-snackbar v-model="snackbarError" :timeout="timeout" color="blue" right>
      {{ textError }}
    </v-snackbar>

    <div id="mapContainer" class="DimensionMap"></div>

    <ButtonScroll />
    <Footer />
  </div>
</template>
<script>
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
import ButtonScroll from "../components/ButtonScroll.vue";
import moment from "moment";
import mapboxgl from "mapbox-gl";
import { dbRealtimeSolicitudInformacionAR } from "../main";
import axios from "axios";

export default {
  data() {
    return {
      Request: {
        Fecha: moment().format("Do MMMM YYYY, h:mm:ss a"),
        Nombre: "",
        Apellido: "",
        Correo: "",
        Telefono: "",
        Comentario: "",
      },
      loading: false,
      itemsBreadcrumbs: [
        {
          text: "HOME",
          disabled: false,
          href: "/",
        },
        {
          text: "CONTÁCTENOS",
          disabled: true,
          href: "",
        },
      ],
      nombreRules: [
        (v) => !!v || "Name es obligatorio",
        (v) => (v && v.length <= 10) || "No puede exceder mas de 10 caracteres",
      ],
      apellidoRules: [
        (v) => !!v || "Apellido es obligatorio",
        (v) => (v && v.length <= 10) || "No puede exceder mas de 10 caracteres",
      ],
      emailRules: [
        (v) => !!v || "Correo es obligatorio",
        (v) => /.+@.+\..+/.test(v) || "Correo invalido",
      ],
      valid: true,
      map: "",
      accessToken:
        "pk.eyJ1Ijoiam9obmxpbmFyZXMiLCJhIjoiY2tjcWk2eDZrMTU2bjJyczVyMWF0ejg3NiJ9.848u9JaZDYfKTRPBzFvDwA",
      itemsContacto: [
        {
          titulo: "Dirección",
          descripcion:
            "<span class='text--primary'>PROLONGACION 87 AV. SUR COL. MAQUILISHUAT #4 SAN SALVADOR, EL SALVADOR</span>",
          icon: "fas fa-map-marker-alt fa-2x",
        },
        {
          titulo: "Teléfono",
          descripcion: "<span class='text--primary'>(503) 2508-4000</span>",
          icon: "fas fa-phone-alt fa-2x",
        },
        {
          titulo: "Correo",
          descripcion:
            "<span class='text--primary'>marketing@asistenciaregional.com</span>",
          icon: "fas fa-envelope fa-2x",
        },
      ],
      snackbarSuccess: false,
      snackbarError: false,
      textSuccess: "Datos enviados con exito.",
      textError: "No se pudo enviar.",
      timeout: 2500,
      //Variables de telegram
      chatGrupoId: -1001512403640,
      chatId: 607062080,
      tokenTelegram: "5024387664:AAGrXKGayYOFsALSYEYkHseAPe2TgZbFjF4",
    };
  },

  components: {
    Header,
    Footer,
    ButtonScroll,
  },

  mounted() {
    mapboxgl.accessToken = this.accessToken;
    this.map = new mapboxgl.Map({
      container: "mapContainer",
      style: "mapbox://styles/mapbox/streets-v11",
      center: [-89.24173, 13.699239],
      zoom: 15,
    });

    var marker = new mapboxgl.Marker({ color: "blue" })
      .setLngLat([-89.24173, 13.699239])
      .setPopup(
        new mapboxgl.Popup({ offset: 25 }).setHTML(
          "<strong>Asistencia Regional</strong>"
        )
      )
      .addTo(this.map);

    this.map.addControl(new mapboxgl.FullscreenControl());

    this.map.addControl(
      new mapboxgl.GeolocateControl({
        positionOptions: {
          enableHighAccuracy: true,
        },
        trackUserLocation: true,
      })
    );
    this.map.addControl(new mapboxgl.NavigationControl());

    this.map.addControl(
      new MapboxDirections({
        accessToken: mapboxgl.accessToken,
      }),
      "top-left"
    );
  },
  created() {
    this.generateRandomCode();
  },

  methods: {
    enviarSolicitud() {
      this.loading = true;
      dbRealtimeSolicitudInformacionAR
        .child("Solicitudes")
        .child(this.generateRandomCode())
        .set(this.Request)
        .then((response) => {
          this.notificacionTelegram();
          this.limpiar();
          this.snackbarSuccess = true;
        })
        .catch((error) => {
          console.log("error", error);
          this.loading = false;
          this.snackbarError = true;
        });
    },
    generateRandomCode() {
      var resultado = "";
      var caracteres =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      for (var i = 0; i < 20; i++) {
        resultado += caracteres.charAt(
          Math.floor(Math.random() * caracteres.length)
        );
      }
      return resultado;
    },
    notificacionTelegram() {
      var mensaje =
        "SE HA GENERADO UNA SOLICITUD DE INFORMACION PARA ASISTENCIA REGIONAL" +
        "%0A" +
        "VERIFICAR EN EL SISTEMA DE SOLICITUD AR" +
        "%0A" +
        "FECHA: " +
        this.Request.Fecha +
        "%0A" +
        "NOMBRE: " +
        this.Request.Nombre +
        "%0A" +
        "APELLIDO" +
        this.Request.Apellido +
        "%0A" +
        "CORREO: " +
        this.Request.Correo +
        "%0A" +
        "TELEFONO: " +
        this.Request.Telefono +
        "%0A" +
        "COMENTARIO: " +
        this.Request.Comentario;

      axios
        .post(
          "https://api.telegram.org/bot" +
            this.tokenTelegram +
            "/sendMessage?chat_id=" +
            this.chatGrupoId +
            "&text=" +
            mensaje
        )
        .then((response) => {
          console.log("Mensaje enviado", response.status);
        })
        .catch(function (error) {
          console.log("error", error);
        });
    },
    limpiar() {
      this.Request.Nombre = "";
      this.Request.Apellido = "";
      this.Request.Correo = "";
      this.Request.Telefono = "";
      this.Request.Comentario = "";
      this.loading = false;
      this.reset();
    },
    validate() {
      this.$refs.form.validate();
    },
    reset() {
      this.$refs.form.reset();
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Zilla+Slab:ital,wght@1,700&display=swap");
@import url("https://fonts.googleapis.com/css2?family=EB+Garamond:wght@500&family=Zilla+Slab:ital,wght@1,700&display=swap");

.fontTitulo {
  font-family: "EB Garamond", serif;
  font-size: 35px;
}
.fontTituloResponsive {
  font-family: "EB Garamond", serif;
  font-size: 20px;
}
.DimensionMap {
  width: 100%;
  height: 400px;
}
</style>
